/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export default function CampaignLayoutCampaignContent() {
  return (
    <div>
      <div>
        <h2 className="helpHeaderTitle">Campaigns & Content </h2>
        <div className="helpContentSection">
          {" "}
          <div className="imageRow mb-3">
            <div className="imageSection">
              {" "}
              <img
                alt=""
                src={require("../../assets/images/helpCenter/campaignCenterImg1.png")}
              />
            </div>
            <div className="imageInfoSection">
              <div className="boldTitle">Create Campaign </div>
              <div>
                In the campaign tab, click “Add Campaign” or edit an existing
                campaign by clicking on its title.
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Add Content (1)</div>
            <div>
              Drag content and Playlists from the media library directly to the
              screen it will play on OR corresponding region below. Content
              duration (videos will auto-fill to their actual length, and static
              images should generally be 15 seconds) can be changed by clicking
              on the content.
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Sort Content (2)</div>
            <div>
              Order content by dragging and dropping along the timeline in the
              bottom region OR click on the three stacked lines to open the
              “Drag to Sort Window” and move content up and down.
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Sizing the Regions (3) </div>
            <div>
              Screen size can be adjusted by either dragging and dropping its
              corners in the editor window OR by selecting the region in the
              timeline and clicking the gear icon to enter the specific sizing
              numbers.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/campaignCenterImg2.png")}
          />
        </div>
      </div>
    </div>
  );
}
